// Central place to edit business details displayed across the site.
export const SITE = {
  name: "SeaShells Care",
  tagline: "Premium live-in & home care, with heart.",
  region: "Epping Forest, Harlow & Bishop's Stortford",
  phone: "01992 892894",
  phoneHref: "tel:+441992892894",
  email: "info@seashellcare.com",
  emailHref: "mailto:info@seashellcare.com",
  address: {
    region: "Epping Forest, Harlow & Bishop's Stortford",
    country: "United Kingdom",
  },
  hours: "Office: Mon–Fri 9am–6pm  •  Care line: 24/7",
  logoUrl:
    "https://static.wixstatic.com/media/0982a8_3297b0f868b3497097bf16a79cf572d7~mv2.png/v1/fill/w_368,h_368,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Final-Logo-with-Strapline-onWHITE.png",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Live-In Care", to: "/live-in-care" },
  { label: "Overnight Care", to: "/overnight-care" },
  { label: "Visiting Care", to: "/visiting-care" },
  { label: "Areas", to: "/locations" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const TRUST = [
  {
    name: "CQC Rated Good",
    sub: "Care Quality Commission",
    icon: "fa-award",
  },
  {
    name: "UKHCA Member",
    sub: "Homecare Association",
    icon: "fa-shield-halved",
  },
  {
    name: "Family-Run",
    sub: "Founded by carers",
    icon: "fa-hand-holding-heart",
  },
  {
    name: "Local to Essex",
    sub: "Epping, Harlow & Bishop's Stortford",
    icon: "fa-location-dot",
  },
];

export const AWARDS = [
  {
    year: "2024",
    title: "Top 20 Home Care Providers",
    region: "East of England",
    source: "homecare.co.uk",
    badge: "/brand/award-top20-2024.svg",
  },
  {
    year: "2023",
    title: "Top 20 Home Care Providers",
    region: "East of England",
    source: "homecare.co.uk",
    badge: "/brand/award-top20-2023.svg",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "From the very first call, SeaShells understood. Mum has the same carer every morning now — they have proper conversations, and I finally sleep through the night.",
    name: "Rebecca H.",
    role: "Daughter — Epping",
  },
  {
    quote:
      "Live-in care felt huge to arrange. SeaShells walked us through every step and matched Dad with a carer who genuinely loves classical music as much as he does.",
    name: "James M.",
    role: "Son — Harlow",
  },
  {
    quote:
      "Knowing the same carer is there overnight has given my whole family our lives back. They are warm, professional and unbelievably kind.",
    name: "Priya S.",
    role: "Daughter — Loughton",
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "A friendly first call",
    body:
      "Speak to a real member of our family team — no scripts, no pressure. We listen, then explain what's possible.",
  },
  {
    step: "02",
    title: "Free in-home assessment",
    body:
      "We visit at a time that suits you, meet your loved one, and shape a care plan around the life they already love.",
  },
  {
    step: "03",
    title: "Carefully matched carer",
    body:
      "We match on personality and interests as much as skill. The same trusted carer, every visit — never a stranger.",
  },
  {
    step: "04",
    title: "Care that grows with you",
    body:
      "We review regularly, adjust gently and stay close — so the right level of support is always there.",
  },
];
